export const getAdvertiserContactMessage = ({
  firstName,
  lastName,
  email,
  phone,
  message,
  url,
}: {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string | undefined;
  url: string | undefined;
}) => {
  return {
    blocks: [
      {
        type: 'section',
        text: {
          type: 'mrkdwn',
          text: `Potential Advertiser - *${
            url
              ? `<${url}|${firstName} ${lastName}>`
              : `${firstName} ${lastName}`
          }*`,
        },
      },
      {
        type: 'section',
        fields: [
          {
            type: 'mrkdwn',
            text: `*Advertiser name:*\n${firstName} ${lastName}`,
          },
          {
            type: 'mrkdwn',
            text: `*Email:*\n${email}`,
          },
          {
            type: 'mrkdwn',
            text: `*Phone number:*\n${phone}`,
          },
          message
            ? {
                type: 'mrkdwn',
                text: `*Message:*\n${message}`,
              }
            : undefined,
        ],
      },
    ],
  };
};
